import api from "@/lib/api";

export const paymentService = {
  checkout: (packageId) =>
    api.post("/payments/checkout", { package_id: packageId, origin_url: window.location.origin }).then((r) => r.data),
  status: (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data),
};
